import MediaControls from 'components/mediaControls/mediaControls.module';
import { MessageWrapper } from 'components/messageWrapper/messageWrapper.module';
import { BOT_MODE, MESSAGE_SENDER, MESSAGE_TYPE } from 'consts/enum';
import { generate6DigitUUID, setCustomTagHTML } from 'helpers/helpers';
import { ENGT_CHAT } from 'js/bot.model';
import { SendAudioTemplate } from './sendAudio.template';

const { BOT, USER } = MESSAGE_SENDER;

const getAudioLength = (duration) => {
	let seconds = Math.round(duration % 60);
	let minutes = Math.round(duration / 60);

	if (minutes < 9) {
		minutes = `0${minutes}`;
	}
	if (seconds < 9) {
		seconds = `0${seconds}`;
	}

	return `${minutes}:${seconds}`;
};

export default class SendAudio {
	constructor(props) {
		this.initData(props);
		this.initWrapper();
		this.initComponents();
	}

	initData(propData = {}) {
		this.data = {};
		const { audio_url, audio_caption, enable_download, file_name = '' } = propData.message?.data;
		this.setter({
			...propData,
			audioUrl: audio_url,
			captions: audio_caption,
			enableDownload: enable_download,
			file_name,
			id: propData.message_id || generate6DigitUUID(),
		});
	}

	initWrapper() {
		const { sender = BOT } = this.data;
		const wrapper = document.createElement('div');
		wrapper.classList.add(
			'engt-msg',
			`engt-msg-${sender}`,
			'engt-media-controls-wrapper',
			`engt-msg-border-${sender}`
		);
		wrapper.innerHTML = SendAudioTemplate(this.data);
		wrapper.style.minWidth = ENGT_CHAT.get('config.bot_mode') === BOT_MODE.STANDALONE ? '50%' : '65%';

		this.html = wrapper;
	}

	initComponents() {
		const { sender = BOT, showControls, file_name } = this.data;
		const ref = this;
		const audioControls = new MediaControls({
			message_id: this.data.id,
			mediaId: `engtAudio-${this.data.id}`,
			showControls: sender !== USER,
		});

		if (sender === USER && !showControls) {
			const fileName = file_name ? `<span class="engt-audio-file-name">${file_name}</span>` : '';
			const div = document.createElement('div');
			div.classList.add('engt-audio-user-msg');
			div.appendChild(audioControls.render());
			div.insertAdjacentHTML('beforeend', fileName);

			this.html.appendChild(div);

			const media = this.html.querySelector(`#engtAudio-${ref.data.id}`);
			media.onloadedmetadata = function () {
				setCustomTagHTML(
					document.getElementById(ref.data.id).querySelector('audio-length'),
					`<span>${getAudioLength(this.duration)}</span>`
				);
			};
		} else {
			this.html.appendChild(audioControls.render());
		}

		this.html = new MessageWrapper({
			...this.data,
			message: MESSAGE_TYPE.AUDIO,
			innerHTML: this.html.outerHTML,
			download: this.data.enableDownload,
			downloadLink: this.data.audioUrl,
		});
	}

	setter(propData) {
		this.data = {
			...this.data,
			...propData,
		};
	}

	render() {
		return this.html;
	}
}
